window.addEventListener("DOMContentLoaded", () => {

    // Sections variables
    const neighborhoodSection = document.querySelector('.page-neighborhood');
    const neighborhoodButton = neighborhoodSection.querySelectorAll('.button')[0];

    const messageSection = document.querySelector('.shopify-section--rich-text');
    const firstParagraph = messageSection.querySelector('p:first-of-type');
    const secondParagraph =  messageSection.querySelector('.prose p:nth-of-type(2)');
    const thirdParagraph = messageSection.querySelector('.prose div p');
    const clearRadiusButton = messageSection.querySelector('.button-group');

    const storeSection = document.querySelector('.shopify-section--image-with-text');
    const storeCard = document.querySelectorAll('#store-card');

    // Hide messageSection and storeSection by default
    messageSection.style.display = 'none';
    clearRadiusButton.style.display = 'none';
    storeSection.style.display = 'none';

    // Placeholder functionality
    const input = document.querySelector('.custom-input');
    const placeholder = input.getAttribute('placeholder');

    input.addEventListener('focus', () => {
        input.setAttribute('placeholder', '');
    });

    input.addEventListener('blur', () => {
        input.setAttribute('placeholder', placeholder);
    });

    // Apply Button functionality
    neighborhoodButton.addEventListener('click', () => {
        const input = document.querySelector('.custom-input');
        const regex = /(^\d{5}$)|(^\d{5}-\d{4}$)/; // US zip code regex
        const zipCode = input.value.trim();

        // Validate zip code typed by the user
        if (regex.test(zipCode)) {
            console.log('Valid zip code entered.');
            const validatedZipCode = zipCode.replace(/ /g, ''); // Remove spaces

            // API variables
            const API_KEY = "js-8RIOs5pk3r8N5lQML2LrJa70gcAzoDxTxvzO1QgxYFcWX1urOvtUjukdQZqOKVLd";
            const API_FORMAT = "json"; // Options json, xml, csv
            const API_ZIP_CODE = validatedZipCode;
            const API_DISTANCE = "10"; // Cap at 500 miles
            const API_UNITS = "mile" // Options mile, km
            const API_URL = `https://www.zipcodeapi.com/rest/${API_KEY}/radius.${API_FORMAT}/${API_ZIP_CODE}/${API_DISTANCE}/${API_UNITS}`;

            // Fetch API
            fetch(API_URL)
                .then(response => response.json())
                .then(data => {
                    const zipCodes = data.zip_codes.map(zip => zip.zip_code); // Array of zip codes

                    // Loop through each storeCard element and check if its zip code is in the API array
                    let storeFound = false;
                    storeCard.forEach(storeCard => {
                        const storeCardAddressText = storeCard.textContent;

                        if (zipCodes.some(zipCode => storeCardAddressText.includes(zipCode))) {
                            storeCard.style.display = 'block';
                            storeFound = true;
                        } else {
                            storeCard.style.display = 'none';
                        }
                    });

                    // If at least one store matches the zip codes provided
                    if (storeFound) {
                        // Show both messageSection and storeSection
                        messageSection.style.display = 'block';
                        storeSection.style.display = 'block';

                        // Jump down to messageSection
                        messageSection.scrollIntoView({ behavior: 'smooth' });
                    } else {
                        // If no store matches the zip codes provided
                        // Updates messageSection text and displays the button
                        firstParagraph.style.display = 'none';
                        secondParagraph.textContent = 'No stores found within a 5 mile radius';
                        thirdParagraph.style.display = 'none';
                        clearRadiusButton.style.display = 'flex';
                        
                        // Display messageSection only
                        messageSection.style.display = 'block';
                        storeSection.style.display = 'none';

                        // Jump down to messageSection
                        messageSection.scrollIntoView({ behavior: 'smooth' });

                        console.error('No stores found within a 5 mile radius.');
                    }
                })
                .catch(error => console.error(error));
        } else {
            // Updates messageSection text and displays the button
            firstParagraph.style.display = 'none';
            secondParagraph.textContent = 'Invalid zip code entered';
            thirdParagraph.style.display = 'none';
            clearRadiusButton.style.display = 'flex';

            // Display messageSection only
            messageSection.style.display = 'block';
            storeSection.style.display = 'none';

            // Jump down to messageSection
            messageSection.scrollIntoView({ behavior: 'smooth' });

            console.error('Invalid zip code entered.');
        };
    });

    // Clear Radius Button functionality

    clearRadiusButton.addEventListener('click', () => {
        // Jump back to default view of the page
        neighborhoodSection.scrollIntoView({ behavior: 'smooth' });

        // Clear input field
        const input = document.querySelector('.custom-input');
        const placeholder = input.getAttribute('placeholder');
        input.value = '';
        
        // Updates messageSection text and hides it
        messageSection.style.display = 'none';
        firstParagraph.style.display = 'block';
        secondParagraph.textContent = 'SHOP YOUR NEIGHBORHOOD';
        thirdParagraph.style.display = 'block';
        clearRadiusButton.style.display = 'none';
    });

    // Website Re Arrangement
    const containers = storeSection.querySelectorAll('.store-directory_info');

    containers.forEach(container => {
        const aTag = container.querySelector('a');
        const clonedATag = aTag.cloneNode(true);
        container.removeChild(aTag);
        const h2Tag = container.querySelector('h2');
        container.insertBefore(clonedATag, h2Tag.nextSibling);
    });

    // const aboutTheStore = document.querySelector('.store_bio');
    // const storeCardGrid = document.querySelectorAll('.image-with-text-store');

    // // Update the grid layout based on screen width
    // function updateGridLayout() {
    //     const screenWidth = window.innerWidth;

    //     if (screen >= 1280) {
    //         // Set the grid layout to 9 columns
    //         storeCardGrid.forEach(container => {
    //             container.style.display = 'grid';
    //             container.style.gridTemplateColumns = 'repeat(9, 1fr)';
    //         });

    //         // Set About The Store to take 3 columns starting from the 7th column
    //         aboutTheStore.style.gridColumn = '7 / span 3';
    //     } else if (screenWidth >= 700) {
    //         // Set the grid layout to 6 columns
    //         storeCardGrid.forEach(container => {
    //             container.style.display = 'grid';
    //             container.style.gridTemplateColumns = 'repeat(6, 1fr)';
    //         });

    //         // Set the About The Store to take 3 columns starting from the 4th column
    //         aboutTheStore.style.gridColumn = '4 / span 3';
    //     } else {
    //         // Set the grid layout to 1 column
    //         storeCardGrid.forEach(container => {
    //             container.style.display = 'block';
    //         });

    //         // Set the About The Store to take up the full width
    //         aboutTheStore.style.gridColumn = '1 / -1';
    //     }
    // }

    // // Call the function on page load and on window resize
    // window.addEventListener('load', updateGridLayout);
    // window.addEventListener('resize', updateGridLayout);

});